import { useEffect } from 'react';
import { HelpChat } from '../components/HelpChat';

/**
 * Standalone route rendered inside an <iframe> on external sites (e.g. targetfunder.com).
 * Body is transparent so only the floating bubble / chat window are visible.
 * Posts { type: 'tf-chat', open } to parent so the iframe can resize itself.
 */
export default function ChatEmbed() {
  useEffect(() => {
    const prevBody = document.body.style.background;
    const prevHtml = document.documentElement.style.background;
    document.body.style.background = 'transparent';
    document.documentElement.style.background = 'transparent';
    return () => {
      document.body.style.background = prevBody;
      document.documentElement.style.background = prevHtml;
    };
  }, []);

  return (
    <div data-testid="chat-embed-root" style={{ background: 'transparent', minHeight: '100vh' }}>
      <HelpChat pageContext="marketing-embed" embedMode />
    </div>
  );
}
